<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            @click="$router.go(-1)"
            elevation="0"
            outlined
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            py-2
            px-6
            me-2
            mb-sm-0 mb-4
          "
            color="#5e72e4"
            small
        >
          <v-icon size="16">fas fa-arrow-left me-1</v-icon>
          Back
        </v-btn>
      </div>
      <v-row>
        <v-col lg="12" class="mx-auto">
          <v-card class="card-shadow border-radius-xl">
            <div class="px-4 pt-4">
              <div class="d-flex align-center">
                <div>
                  <h6 class="text-h6 text-typo font-weight-bold mb-2">
                    Organisation Details
                  </h6>
                </div>
                <v-btn
                    outlined
                    rounded
                    elevation="0"
                    :ripple="false"
                    height="43"
                    class="
                    text-uppercase
                    font-weight-bold
                    text-uppercase
                    btn-default btn-outline-default
                    py-2
                    px-6
                    me-2
                    ms-auto
                  "
                    small
                >
                  <v-icon size="16">fas fa-user me-1</v-icon>
                  {{ companyInfo.officer }}
                </v-btn>
              </div>
            </div>
            <div class="px-4 pb-4">
              <hr class="horizontal dark mt-0 mb-6" />
              <v-row>
                <v-col md="6">
                  <div class="d-flex">
                    <v-avatar
                        class="me-4 border-radius-lg"
                        alt="product-image"
                        width="150px"
                        height="110px"
                    >
                      <v-img
                          class="navbar-brand-img ms-3"
                          width="20"
                          src="@/assets/img/construction.jpeg"
                      >
                      </v-img>
                    </v-avatar>
                    <div>
                      <h6
                          class="
                          text-h6 text-typo text-lg
                          font-weight-bold
                          mb-0
                          mt-2

                        "
                      >
                        {{ (companyInfo.trading_as).toUpperCase() }}
                        <small>({{ companyInfo.registration_number }})</small>
                      </h6>
                      <small class="text-mute text-small mb-2">
                        {{ (companyInfo.business_address ).toUpperCase() }}
                      </small>
                      <p class="text-sm text-body mb-1">
                        {{ companyInfo.date_of_registration }} to Present
                      </p>
                      <v-btn
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                          border-radius-sm
                          text-xxs
                          font-weight-bolder
                          px-3
                          py-2
                          badge-font-size
                          ms-auto
                          text-white
                        "
                          :class = "companyInfo.is_active ? 'bg-gradient-success' : 'bg-gradient-danger'"
                          color="#cdf59b"
                      >
                        {{companyInfo.is_active
                          ? 'Active'
                          : 'Inactive' }}
                        {{  }}</v-btn
                      >
                    </div>
                  </div>
                </v-col>
                <v-col md="6">
                  <div class="d-flex">
                    <v-avatar
                        class="me-4 border-radius-lg"
                        alt="product-image"
                        width="100px"
                        height="110px"
                    >
                      <v-img
                          class="navbar-brand-img ms-3"
                          width="10"
                          src="@/assets/necUser.png"
                      >
                      </v-img>
                    </v-avatar>
                    <div>
                      <h6
                          class="
                          text-h6 text-typo text-lg
                          font-weight-bold
                          mb-0
                          mt-2
                          mb-1
                        "
                      >
                        {{ (companyInfo.contact_name).toUpperCase() }}
                      </h6>
                      <p class="text-sm text-body mb-3">
                        {{ companyInfo.email }}
                      </p>
                      <v-btn
                          elevation="0"
                          large
                          :ripple="false"
                          height="21"
                          class="
                          border-radius-sm
                          text-xxs
                          font-weight-bolder
                          px-3
                          py-2
                          badge-font-size
                          ms-auto
                          text-white
                          bg-gradient-secondary
                        "
                          color="#cdf59b"
                      >
                        <v-icon size="small">
                          fas fa-phone-alt
                        </v-icon>
                        &nbsp;
                        {{companyInfo.telephone}}
                        </v-btn
                      >
                    </div>
                  </div>
                </v-col>
                <v-col md="6" v-if="false" class="text-end my-auto">
                  <v-select
                      v-model="action"
                      label="Select Action"
                      :items="['Approve', 'Reject']"
                  ></v-select>
                  <v-select
                      v-model="regions"
                      label="Select Regions"
                      :items="['Harare', 'Bulawayo', 'Midlands', 'Mashonaland', 'Manicaland', 'Masvingo', 'Matabeleland', 'Matebeleland South', 'Matebeleland North', 'Mashonaland East', 'Mashonaland West', 'Mashonaland Central']"
                  ></v-select>
                  <v-btn
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="
                    font-weight-bold
                    text-uppercase
                    btn-default
                    bg-gradient-secondary
                    py-2
                    px-6
                    me-2
                    ms-auto
                  "
                      color="#5e72e4"
                      small
                  >Update</v-btn
                  >
                </v-col>
              </v-row>
              <hr class="horizontal dark my-6" />
              <v-row v-if="false">
                <v-col lg="2" md="2">

                </v-col>
                <v-col lg="8" md="8">
                  <h6 class="text-h6 text-typo font-weight-bold mb-3">
                    Trade details
                  </h6>
                  <div
                      class="d-flex flex-column bg-gray-100 pa-6 border-radius-lg"
                  >
                    <h6 class="text-typo font-weight-bold mb-4 text-sm">
                      {{ companyInfo.company_name }}
                    </h6>
                    <span class="mb-2 text-body text-xs"
                    >Business Address:
                      <span class="text-dark font-weight-bold ms-2"
                      >{{ companyInfo.business_address }}</span
                      ></span
                    >
                    <span class="mb-2 text-body text-xs"
                    > Business Type:
                      <span class="text-dark ms-2 font-weight-bold"
                      > {{ companyInfo.business_type }}</span
                      ></span
                    >
                    <span class="text-xs text-body"
                    >Trades Perfomed:
                      <span class="text-dark ms-2 font-weight-bold"
                      >{{ companyInfo.trades_performed }}</span
                      ></span
                    >
                  </div>
                </v-col>
                <v-col lg="2" md="2" >
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col lg="12" cols="12">
          <v-card class="card-shadow border-radius-xl h-100">
            <div class="px-4 pt-4">
              <h6 class="mb-0 text-h6 text-typo font-weight-bold">
                Ledgers
              </h6>
            </div>
            <div class="px-4 py-4">
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="headers"
                      :items="batchInfo"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                  item.status == 'Approved'
                    ? 'border-success'
                    : 'border-warning'
                "
                        >
                          <v-icon
                              size="8"
                              :class="
                    item.status == 'Approved'
                      ? 'text-success'
                      : 'text-warning'
                  "
                          >
                            fas fa-check
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.status }}</span>
                      </div>
                    </template>

                    <template v-slot:item.date_received="{ item }">
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-bold">{{
                            item.date_received
                          }}</span>
                      </div>
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-light">{{
                            item.payment_type
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.week_number="{ item }">
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-bold">{{
                            item.month + " " + item.year
                          }}</span>
                      </div>
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-light">{{
                            item.week_number
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.general_fund="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold"> $ {{
                          formatPrice(item.general_fund)
                        }}</span>
                    </template>

                    <template v-slot:item.other="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.other)
                        }}</span>
                    </template>

                    <template v-slot:item.currency="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold"> {{
                          item.currency
                        }}</span>
                    </template>

                    <template v-slot:item.unallocated_amount="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.unallocated_amount)
                        }}</span>
                    </template>

                    <template v-slot:item.interest="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.interest)
                        }}</span>
                    </template>

                    <template v-slot:item.total_amount="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.total_amount)
                        }}</span>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-btn
                          @click="goToView(item)"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                          :class="
                    item.status == 'Approved'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >{{item.statusIcon == 'fas fa-check'
                          ? 'View'
                          : 'View'}}</v-btn
                      >
                    </template>

                    <template v-slot:item.download="{ item }">
                      <v-btn
                          @click=""
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2

                  "
                          :class="
                    item.status == 'Approved'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Download
                      </v-btn
                      >
                    </template>


                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  data() {
    return {
      companyInfo: [],
      page: 1,
      pageCount: 0,
      batchInfo: [],
      itemsPerPage: 10,
      timeline: [
        {
          title: "Order received",
          date: "22 DEC 7:20 PM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-bell-55",
          btn: "secondary",
        },
        {
          title: "Generate order id #1832412",
          date: "22 DEC 7:21 AM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-html5",
          btn: "secondary",
        },
        {
          title: "Order transmited to courier",
          date: "22 DEC 8:10 AM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-cart",
          btn: "secondary",
        },
        {
          title: "Order delivered",
          date: "22 DEC 4:54 PM",
          color: "#b0eed3",
          iconColor: "#1aae6f",
          icon: "ni-check-bold",
          btn: "success",
        },
      ],
      documents: [
        {
          user: "Proof of Payment",
        },
        {
          user: "Director ID Document",
        },
        {
          user: "Proof of Residence",
        },
        {
          user: "NSSA Documentation",
        },
      ],
      headers: [
        {
          text: "Weeks #",
          align: "start",
          sortable: false,
          value: "week_number",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Status",
          value: "status",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Received Date",
          value: "date_received",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Other",
          value: "other",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Unallocated",
          value: "unallocated_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Interest",
          value: "interest",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Currency",
          value: "currency",
          class: "text-secondary font-weight-bolder opacity-7",
        },

        {
          text: "Total Amount",
          value: "total_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },

      ],
    };
  },
  computed: {
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  created() {
    this.getcompanyInfo()
  },
  methods: {
    async getBatchRecords(val) {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/ledger/records/' + val, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.batchInfo = res.data
              console.log(this.batchInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async getcompanyInfo() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/auth/get-organisation-info/' + this.$route.query.id, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.companyInfo = res.data
              this.getBatchRecords(this.companyInfo.registration_number)
              console.log(this.companyInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    openPdf () {
      window.open('https://imgv2-2-f.scribdassets.com/img/document/511132757/original/2d01f52d21/1686891931?v=1');
    },
    goTo(){
      this.$router.push("/admin-returns");
    }
  },
};
</script>
